// TODO: Ideally we would remove this store, but we would need to find another way to inject the nonce into every
// request, so I left it from the time being. The same thing for the logout event being raised

let NONCE: string | undefined;

export const getNonce = () => NONCE;

export const setNonce = (nonce: string | undefined) => {
  NONCE = nonce;
}

export const raiseLogoutEvent = () => {
  window.dispatchEvent(new Event('logout'));
};
